module.exports = __webpack_public_path__ + "img/SPP2130_Logo_4C_cr.ad15100a.svg";